import { FC } from 'react'
import { Link as RouterLink, LinkProps } from 'react-router-dom'
import { Link as A, Paragraph } from '@entur/typography'

interface Props extends LinkProps {
  disabled?: boolean
}

export const Link: FC<Props> = (props) => {
  return (
    <>
      {!props.disabled && (
        <A {...props} as={RouterLink}>
          {props.children}
        </A>
      )}
      {props.disabled && (
        <Paragraph className={props.className} as={A} style={{ color: '#d1d3d3' }}>
          {props.children}
        </Paragraph>
      )}
    </>
  )
}
